<template>

<div>

<section class="pt-0 pb-3">
  <form v-on:submit.prevent="getInstances">

    <h2 v-if="preloaded == true">{{ tourName }}</h2>

    <div class="row">

      <div class="col" v-if="$root.tours && preloaded == false">
        <div class="form-group">
          <label for="tour">Chosen tour:</label>
          <div class="form-group">
            <v-select
              v-model="$root.tour"
              id="tour"
              :options="$root.tours"
              index="id"
              label="name"
              v-on:option:selected="tourOnChange"
            >
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!$root.tour"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
        </div>
      </div>

      <template v-if="$root.tour">

        <div class="col" v-if="$root.tour.tour_type == 'self-drive'">
          <div class="form-group">
              <label for="departureDate">Preferred departure date:</label>
          </div>
        </div>

        <div class="col" v-if="airports && $root.tour.tour_type == 'air'">
          <div class="form-group">
            <label for="departureAirport">Preferred departure airport:</label>
            <div class="form-group">
            <v-select
              v-model="$root.departureAirport"
              id="departureAirport"
              :options="airports"
              index="id"
              label="airport_name"
              :reduce="airport => airport.id"
              required
            >
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!$root.departureAirport"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
            </div>
          </div>
        </div>

        <div class="col" v-if="regions && $root.tour.tour_type == 'coach'">
          <div class="form-group">
            <label for="departureRegion">Departure region:</label>
            <div class="form-group">
            <v-select
            v-model="$root.departureRegion"
            id="departureRegion"
            :options="regions"
            index="id"
            label="region_name"
            required
            >
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!$root.departureRegion"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
            </div>
          </div>
        </div>

        <!-- <div class="col" v-if="$root.tour.tour_type == 'self-drive'">
          <div class="form-group">
            <label for="departureAirport">Departure region:</label>
            <div class="form-group">
            <v-select
            v-model="$root.departureRegion"
            id="departureRegion"
            :options="regions"
            index="id"
            label="region_name"
            required
            >
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!$root.departureRegion"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
            </div>
          </div>
        </div> -->


        <div class="col" v-if="regions && $root.tour.tour_type == 'coach' && $root.departureRegion !== null">
          <div class="form-group">
            <label for="departureAirport">Pick-up point:</label>
            <div class="form-group">
            <v-select
            v-model="$root.departurePoint"
            id="departurePoint"
            :options="$root.departureRegion.pick_up_points"
            index="id"
            label="pickup_point_name"
            >
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
            </div>
          </div>
        </div>

      </template>

    </div>
    <div class="row">
      <div class="col-md-6">
        <button type="submit" class="btn btn-primary" v-if="$root.tourInstances.length > 0">Update tour dates</button>
        <button type="submit" class="btn btn-primary" v-else>Show tour dates</button>
      </div>
    </div>
  </form>
</section>
<div class="row" v-if="$root.tourInstances.length > 0">
  <div class="col-md-12 text-right">
    <div class="form-check form-switch">
      <input class="form-check-input" type="checkbox" v-model="hideSoldOut" v-on:change="handleSoldOut">
      <label class="form-check-label"> Hide sold out </label>
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col-md-12">
    <section class="pt-0" v-if="$root.tourInstances.length > 0">
      <div class="table-responsive">
        <table class="table table-sm tour-instances-table ">
          <thead class="thead-light">
            <tr>
              <th scope="col">Departure date</th>
              <th scope="col" v-if="$root.tour.tour_type == 'air'">Departure airport</th>
              <th scope="col" v-else-if="$root.tour.tour_type == 'coach'">Pickup Point</th>
              <th scope="col">Prices from</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(instance, index) in $root.tourInstances">
              <tr :key="index" v-if="instance.show_sold_out_timmings">
                <td>{{ instance.departure_date | formatDate }}</td>
                <td v-if="$root.tour.tour_type == 'air' && instance.airport">{{ instance.airport.airport_name }}</td>
                <td v-else-if="$root.tour.tour_type == 'coach' && instance.pick_up_point">{{ instance.pick_up_point.pickup_point_name }} <small>({{ instance.group.pick_up_point_region.region_name }})</small></td>
                <td>{{ instance.from_price | formatCurrency }}</td>
                <td v-if="instance.group.stop_sell || instance.stop_sell">SOLD OUT</td>
                <td v-else><button class="btn btn-sm btn-primary" v-on:click="bookInstance(instance)">Book now</button></td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </section>
  </div>
</div>

<section class="pt-0" v-if="$root.tourInstances.length == 0 && instancesLoaded == true">
  <h3>Sorry, but we don't have this tour available from your desired airport at the moment</h3>
  <p>Please try again with another airport selected. Alternatively please <a href="/air-holidays">take a look at our other tours</a> or sign up to our newsletter using the form below to be notified when we have new tour dates available.</p>
</section>

</div>

</template>

<script>
import axios from 'axios'
import moment from 'moment'
export default {
  name: 'Tour',
  data () {
    return {
      preloaded : false,
      tourName: null,
      instancesLoaded: false,
      airports: null,
      regions: null,
      pick_up_points: null,
      tourRef: null,
      tour: null,
      tours: [],
      hideSoldOut:false,
    }
  },
  created () {
	  let uri = window.location.search.substring(1);
    let params = new URLSearchParams(uri);
	  this.tourRef = params.get("tour");

    this.getCountries()
    this.getTours()
    if (this.tourRef) {
      this.getAirportForTour(this.tourRef);
    }
    this.getRegions()
    // Set uk as default country
    this.$root.booking.customer.country_id = 220
    this.$root.instance = null
    this.$root.booking.tour_bookings = []
  },
  methods: {
    getCountries () {
      this.$root.loading = true;
      axios.get(this.$root.$api + 'countries')
      .then(res => res.data)
      .then(response => {
        this.$root.countries = response.data
        this.$root.loading = false
      })
    },
    getAirports () {
      this.$root.loading = true;
      axios.get(this.$root.$api + 'airports/active')
      .then(res => res.data)
      .then(response => {
        const airportsObj = response.data
        const airportsArray = Object.keys(airportsObj).map(i => airportsObj[i])
        console.log(airportsArray);
        
        this.airports = airportsArray.sort((a, b) => a.airport_name.localeCompare(b.airport_name));

        this.$root.loading = false
      })
    },
    /**
     * Get available airports for a tour
     */
    getAirportForTour(tour) {
      this.$root.loading = true;
      axios.get(this.$root.$api+'airports/active/'+tour)
        .then(res => res.data)
        .then(json => {
          this.airports = json.data.sort((a, b) => a.airport_name.localeCompare(b.airport_name));;
          this.$root.loading = false
        });
    },
    getRegions () {
      this.$root.loading = true;
      axios.get(this.$root.$api + 'pickup/regions')
      .then(res => res.data)
      .then(response => {
        this.regions = response.data
        this.$root.loading = false
      })
    },
    getTours () {
      this.$root.loading = true;
      axios.get(this.$root.$api + 'tours')
      .then(res => res.data)
      .then(response => {
        this.$root.tours = response.data.filter(tour => tour.stop_sell === false);
        this.$root.loading = false;

        // Set tour based on query parameter

        if (this.tourRef) {
          var selectedTour = this.$root.tours.filter(obj => {
            return obj.reference === this.tourRef;
          });
          this.preloaded = true
          this.$root.tour = selectedTour[0]
          this.tourName = selectedTour[0].name
        }
      })
    },
    getInstances () {
      this.$root.loading = true
      this.instancesLoaded = false
      let This = this 
      if(this.$root.tourInstances == 0) {
        // console.log('no instances');
      }

      if(this.$root.departureRegion !== null) {
        if(this.$root.departurePoint) {
          this.pickUpPoints = []
          this.pickUpPoints.push(this.$root.departurePoint.id)
        } else {
          this.pickUpPoints = this.$root.departureRegion.pick_up_points.map(point => point.id);
        }
      }
      axios.post(this.$root.$api + 'tours/instances/search', {
        tour: this.$root.tour.id,
        airport: this.$root.departureAirport,
        pick_up_points: this.pickUpPoints,
        tour_type: this.$root.tour.tour_type,
      })
      .then(res => res.data)
      .then(json => {
        
        this.$root.tourInstances = json.data.instances;
        this.$root.accommodationNewDesign = json.data.main_setting_for_accommodation.value

        this.$root.tourInstances.forEach((tourI,index) => {
          const tourDate = new Date(tourI.departure_date).setHours(0, 0, 0, 0);
          let isIndirectFlight = false;
          let departureFlighArray = [];
          let returnFlightArray = [];
          /**
           * First Check if Flight count is 2
           * ie., It means there is Only one Inbound and one Outbound Flight
           */
          if (tourI.flights.length == 2) {
            departureFlighArray.push(tourI.flights.reduce((carry, flight) => {
              const flightDate = new Date(flight.departure_time).setHours(0,0,0,0);
              return (flightDate === tourDate) ? flight : carry;
            }, null))

            returnFlightArray.push(tourI.flights.reduce((carry, flight) => {
              const flightDate = new Date(flight.departure_time).setHours(0,0,0,0);
              return (flightDate !== tourDate) ? flight : carry;
            }, null))
            
          } else {

            // Get Inbound Flights Array
            let inboundFlights = tourI.flights.filter((item) => item.pivot.indirect_inbound == 1)
            // Get Outbount Flights Array
            let outBoundFlights = tourI.flights.filter((item) => item.pivot.indirect_outbound == 1)

            if (inboundFlights.length > 0  && outBoundFlights.length > 0 ) {
              departureFlighArray = outBoundFlights
              returnFlightArray = inboundFlights
              isIndirectFlight = true;
            } else {
              departureFlighArray.push(tourI.flights.reduce((carry, flight) => {
                const flightDate = new Date(flight.departure_time).setHours(0,0,0,0);
                return (flightDate === tourDate) ? flight : carry;
              }, null))

              returnFlightArray.push(tourI.flights.reduce((carry, flight) => {
                const flightDate = new Date(flight.departure_time).setHours(0,0,0,0);
                return (flightDate !== tourDate) ? flight : carry;
              }, null))
            }
          }

          tourI.departureFlight = departureFlighArray
          tourI.returnFlight = returnFlightArray
          
          // Calculate Departure fligh Depart time
          const minDepartureDepartTime = new Date(Math.min(...departureFlighArray.map(flight => 
              new Date(flight.departure_time).getTime()
          )));
          // Calculate Departure fligh Arrival time
          const maxDepartureArrivalTime = new Date(Math.max(...departureFlighArray.map(flight => 
              new Date(flight.arrival_time).getTime()
          )));

          // Calculate Arrival fligh Depart time
          const minArrivalFlightDepartTime = new Date(Math.min(...returnFlightArray.map(flight => 
              new Date(flight.departure_time).getTime()
          )));
          // Calculate Departure fligh Arrival time
          const maxAririvalFlightArrivalTime = new Date(Math.max(...returnFlightArray.map(flight => 
              new Date(flight.arrival_time).getTime()
          )));

          // Calculate Departure fligh Depart and Arrival time
          tourI.departureFlightDepartDateTime = this.formatDate(minDepartureDepartTime)
          tourI.departureFlightArrivalDateTime = this.formatDate(maxDepartureArrivalTime)
          // Calculate Arrival fligh Depart and Arrival time
          tourI.ArrivalFlightDepartDateTime = this.formatDate(minArrivalFlightDepartTime)
          tourI.ArrivalFlightArrivalDateTime = this.formatDate(maxAririvalFlightArrivalTime)

          tourI.isIndirectFlight = isIndirectFlight;

          // tourI.departureFlight = tourI.flights.reduce((carry, flight) => {
          //   const flightDate = new Date(flight.departure_time).setHours(0,0,0,0);
          //   return (flightDate === tourDate) ? flight : carry;
          // }, null);
          // tourI.returnFlight = tourI.flights.reduce((carry, flight) => {
          //   const flightDate = new Date(flight.departure_time).setHours(0,0,0,0);
          //   return (flightDate !== tourDate) ? flight : carry;
          // }, null);
          
          if (This.hideSoldOut) {
            this.$root.tourInstances[index]['show_sold_out_timmings'] = (tourI.group.stop_sell || tourI.stop_sell) ? false : true
          }else {
            this.$root.tourInstances[index]['show_sold_out_timmings'] = true
          }
        })
        this.instancesLoaded = true
        this.$root.loading = false
      })
    },
    bookInstance: function (instance) {
      // Set the balance due date dynamically from the tour type default due date
      const currentDate = moment(instance.departure_date, 'YYYY-MM-DD HH:mm:ss');
      const newDate = moment(currentDate).subtract(instance.tour.type.default_due_by_days, 'days');
      instance.balance_due = newDate.format('YYYY-MM-DD HH:mm:ss');

      this.$root.instance = instance;
      this.$router.push({ name: 'accommodation' })
      $("html, body").animate({ scrollTop: 0 }, "slow");
    },
    /**
     * When the tour is changed, update the available airports
     */
    tourOnChange(event) {
      this.getAirportForTour(event.reference);
    },
    handleSoldOut(){
      if (this.hideSoldOut) {
        this.$root.tourInstances.forEach((tourInstance, index) => {
          if('show_sold_out_timmings' in tourInstance) {
            this.$root.tourInstances[index]['show_sold_out_timmings'] = (tourInstance.group.stop_sell || tourInstance.stop_sell) ? false : true;
          }
        });
      }else {
        this.$root.tourInstances.forEach((tourInstance, index) => {
          if('show_sold_out_timmings' in tourInstance) {
            this.$root.tourInstances[index]['show_sold_out_timmings'] = true;
          }
        });
      }
    },
    formatDate(date) {
      const pad = (num) => num.toString().padStart(2, '0');
      
      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1); // +1 because months are 0-indexed
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
}
</script>
